import React, { FC, PropsWithChildren } from "react";
import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";

/**
 * ## LoginGuard
 * Guard for login page that redirects authenticated users to dashboard
 */
const LoginGuard: FC<PropsWithChildren> = ({ children }) => {
    const [cookies] = useCookies();
    const auth = cookies.auth;
    
    // If already authenticated, redirect to dashboard
    if (auth) {
        return <Navigate to={'/dashboard'} replace />;
    }
    
    return <>{children}</>;
};

export default LoginGuard;